import {gql} from "@apollo/client/core";
import {ShopSessionsFragment} from "./shop-session-fragment";

export const ShopSessionDashboardFragment = gql`
    fragment ShopSessionDashboardFragment on ShopSessionDashboard {
        shopSessionRealtimeList {
            minutesBack
            sessionCount
        }
        shopSessionCountryRealtimeList {
            locale
            sessionCount
        }
        recentShopSessions {
            ...ShopSessionsFragment
        }
        enrollShopSessions {
            ...ShopSessionsFragment
        }
        checkoutShopSessions {
            ...ShopSessionsFragment
        }
    }
    ${ShopSessionsFragment}
`;
